export default "__VITE_ASSET__Bnpv85tN__"